import axios from '@axios'
import Form from '@/libs/vForm'
import store from '@/store'
const auth = store.state.auth.userData
export default {
 
  namespaced: true,
  state: {},
  getters: {},
  mutations: {
   SET_DRVER_DATA(state,data){
     state.driver=data;
   }

  },
  
  actions: {
     waslDriverSave(ctx,data){
     return new Promise((resolve,reject)=>{


      axios.post(`wasl`, data)
      .then(res => {
        ctx.state.driver.wasl=true;
        if(data.type=="driverDelete"){ctx.state.driver.wasl=false}
        resolve(res.data)
        
        
      })
      .catch(reason => reject(reason.response))
     })

     },

    fetchDrivers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('drivers', { params: queryParams })
          .then(response =>{ resolve(response)})
          .catch(error => reject(error))
      })
    },
    getOwners(ctx) {
      return new Promise((resolve, reject) => {
        axios.get(`userGetLinked`,{params:{type: 'user', user:auth.id}})
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },

    fetchDriver(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`drivers/${id}`)
          .then(response =>{
            //console.log('ddddddddd',response.data)
            ctx.commit("SET_DRVER_DATA",response.data.driver);
         
             resolve(response)
            })
          .catch(error => reject(error))
      })
    },
    deleteDriver(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`drivers/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addDriver(ctx, driverData) {
      
      
      return new Promise((resolve, reject) => {
        axios.post('drivers', driverData)
          .then(response =>{
           
            resolve(response)
          
          })
          .catch(error =>{
         
            reject(error)

          })
      })
    },
    editDriver(ctx, form) {   

      return new Promise((resolve, reject) => {

        axios.put(`drivers/${form.id}`, { ...form , ownerid: form.owner_id})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
